import { render, staticRenderFns } from "./ArticleSource.vue?vue&type=template&id=72c0eda0"
import script from "./ArticleSource.vue?vue&type=script&lang=ts"
export * from "./ArticleSource.vue?vue&type=script&lang=ts"
import style0 from "./ArticleSource.vue?vue&type=style&index=0&id=72c0eda0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports